export const setSelectedItems = (items) => ({ type: 'SELECTED_ITEMS', payload: items });
export const resetSelectedItems = () => ({ type: 'RESET_SELECTED_ITEMS', payload: null });
